angular.module('dpw.components')
    .directive('dpwChosen', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                scope: {
                    chosenName: '@',
                    optionsSource: '=',
                    model: '=',
                    chosenOptions: '=',
                    optionDecorator: '=',
                    isDisabled: '@',
                    required: '=',
                    change: '&',
                    open: '&',
                    close: '&',
                    blur: '&'
                },
                templateUrl: 'dpw-chosen.html',
                compile: function (element, attrs) {
                    var selectElement = element.find('select');
                    if ('isSingle' in attrs) {
                        selectElement.prop('multiple', false);
                    }

                    return function (scope, element) {
                        var baseChosenOptions = {
                            placeholder_text_multiple: 'Click to select multiple options',
                            display_selected_options: false,
                            optionDecorator: scope.optionDecorator
                        };
                        var chosenOptions = $.extend(baseChosenOptions, scope.chosenOptions);
                        var selectElement = element.find('select');
                        var isOpen = false;


                        scope.$watch('model', function (newValue) {
                            updateChosen();
                        }, true);
                        scope.$watch('optionsSource', function (newValue) {
                            if (angular.isArray(newValue) && newValue.length > 0) {
                                updateChosen();
                            }
                        }, true);
                        scope.$watch('isDisabled', updateChosen);
                        selectElement.chosen(chosenOptions);

                        selectElement.on('change', function () {
                            scope.change && scope.change();
                        });

                        selectElement.on('chosen:showing_dropdown', function () {
                            isOpen = true;
                            scope.open && scope.open();
                        });

                        selectElement.on('chosen:hiding_dropdown', function () {
                            isOpen = false;
                            scope.close && scope.close();
                        });

                        var inputElement = element.find('.chosen-choices input');
                        inputElement.on('blur', function () {
                            if (!isOpen) {
                                scope.blur && scope.blur();
                            }
                        });

                        function updateChosen() {
                            selectElement.trigger('chosen:updated');
                            $timeout(function () {
                                selectElement.trigger('chosen:updated');
                            }, 1);
                        }
                    };
                }
            };
        }]
    );



